import { FilterCategory } from "../pages/browse/Browse";

const de = {
  nav: {
    home: "Home",
    browse: "Browse",
    galleries: "Galerien",
    project: "Das Projekt",
  },
  home: {
    slider: {
      title: "Titel",
      photographer: "Fotograf",
      created: "Erstellt",
      description: "Beschreibung",
      rights: "Rechte",
    },
    intro: {
      headline: "Das Chronik-Projekt",
      text: "Bearum, sequi cus aliciducid minum voluptatio exceaque con natem dolenimagnis rest, sequia vero officae nonsed qui nonsed es magnati scillum natur alit audipsum con re simusan isimus dit et magnam earchillitae ratquis illande niendicatium quia ex explia cor sum quia sequiducium ut eos porrum reiunt, que por atateseque sed quis simus ese sum ipsam voloris dolora dolupta tquidempos est es abores evendis dipsapitas maios etur moluptum ditatiaspid esenectati con pliquam usdaepr ectatem et occuptation pre quibus quid modi ulla delis alibus aut omnis magnima ionsedi gnatum landa eicil etur, simoditi offici simillora consequi ommolut.",
    },
    persons: {
      headline: "Nach Personen suchen",
      text: "Hier wird der Stammbaum angezeigt bzw. ein Beispiel mit wenigen Personen drauf",
      button: "Personen suchen",
    },
    intro2: {
      headline: "Titel",
      text: "Text eines individuellen Zwischenelementes",
    },
    objects: {
      headline: "Nach Objekten suchen",
      text: "Kurze Beschreibung …",
    },
    intro3: {
      headline: "Orte in Passeier",
      text: "Text eines individuellen Zwischenelementes",
    },
    map: {
      more: "mehr …",
    },
  },
  browse: {
    headline: (category: string) => `browse > ${category}`,
    headlineCategory: {
      [FilterCategory.None]: "all",
      [FilterCategory.People]: "Personen",
      [FilterCategory.Places]: "Orte",
      [FilterCategory.Objects]: "Objekte",
      [FilterCategory.Groups]: "Gruppen",
      [FilterCategory.Events]: "Ereignisse",
    },
    categoryHeadline: "Suche in",
    people: "Personen",
    objects: "Objekten",
    places: "Orte",
    publications: "Publikationen",
    artworks: "Kunstwerke",
    items: "Gegenstände",
    timeline: "Timeline",
    list: "Liste",
    image: "Img",
    noResults: "Keine Resultate",
    listColumns: {
      column1: {
        [FilterCategory.None]: "",
        [FilterCategory.People]: "Geb.",
        [FilterCategory.Places]: "Gebiet",
        [FilterCategory.Objects]: "Jahr",
      },
      column2: {
        [FilterCategory.None]: "",
        [FilterCategory.People]: "Name",
        [FilterCategory.Places]: "Name",
        [FilterCategory.Objects]: "Titel",
      },
      column3: {
        [FilterCategory.None]: "",
        [FilterCategory.People]: "Geschlecht",
        [FilterCategory.Places]: "Weitere Namen",
        [FilterCategory.Objects]: "Autoren",
      },
      column4: {
        [FilterCategory.None]: "",
        [FilterCategory.People]: "Geburtsort",
        [FilterCategory.Places]: "Ortstyp",
        [FilterCategory.Objects]: "Verlag",
      },
      column5: {
        [FilterCategory.None]: "",
        [FilterCategory.People]: "Gest.",
        [FilterCategory.Places]: "Adresse",
        [FilterCategory.Objects]: "Seitenzahl",
      },
    },
    sex: {
      male: "Männlich",
      female: "Weiblich",
    },
    to: "bis",
    dateOfBirth: "Geboren am",
    dateOfDeath: "Gestorben am",
    mother: "Mutter",
    father: "Vater",
    siblings: "Geschwister",
    children: "Kinder",
    photos: "Fotos",
    webLinks: "Weblinks",
    partOfGroup: "Teil von Gruppe",
    mainCharacterAt: "Hauptfigur bei",
    municipality: "Gemeinde",
    faction: "Fraktion",
    onWorks: "Auf Werken",
    locatedHereToday: "Befindet sich heute hier",
    periodOfOrigin: "Entstehungszeit",
    authorGroup: "Geschaffen von",
    works: "Werke",
    onEvent: "Am Ereignis beteiligt",
    address: "Adresse",
    gps: "GPS",
    placeOfBirth: "Hier geboren/wohnhaft",
    objectPlace: "Objekte (Entstehungsort)",
    eventPlace: "Ist Hauptort",
    groupPlaces: "In Gruppen",
    eventLocationOnEvent: "Am Ereignis beteiligt",
    place: "Entstehungsort",
    dimensions: "Maße",
    material: "Material",
    technique: "Technik",
    partOf: "Teil von",
    contains: "Enthält",
    similarTo: "Ähnliche Werke",
    locationToday: "Befindet sich heute",
    personsOnWork: "Auf dem Werk",
    groupTypes: "Gruppentyp",
    characters: "Personen",
    owner: "Eigentum",
    onEvents: "an Ereignis beteiligt",
    objectAuthor: "Werke",
    periodOfOriginEvent: "Datum (Entstehungszeit)",
    placeEvent: "Hauptort",
    charactersEvent: "Hauptfiguren",
    similarToEvent: "Ähnliche Ereignisse",
  },
  error: {
    headline: "Die Seite konnte nicht gefunden werden",
    text: "Die von Ihnen gesuchte Seite konnte nicht gefunden werden. Bitte überprüfen Sie die URL und versuchen Sie es erneut.",
  },
};

export default de;
